import * as Yup from "yup";
import { messages } from "../../../common/Models/Validations";

export const catalogueInitialValue = {
  museum_id: null,
  date_of_aquisition: "",
  date_of_entry: "",
  accession_no: "",
  dimension_ids: [],
  dimension_values: {
    length: "",
    width: "",
    height: "",
    weight: ""
  },
  attachment_ids: [],
  translations: {
    en: {
      accession_no: "",
      ownership: null,
      classification: null,
      // object_type: "", 
      object_name: "",
      sub_group: null,
      acquisition: null,
      material: null,
      dyes: "",
      motifs: "",
      description: "",
      condition: null,
      location: null,
      place_of_origin: null,
      source: null,
      source_remarks: "",
      price: "",
      provenance: "",
      exhibition_history: "",
      other_info: "",
    },
  },
};

export const catalogueValidation = Yup.object().shape({
  translations: Yup.object().shape({
    en: Yup.object().shape({
      ownership: Yup.mixed().required(messages.required),
      accession_no: Yup.mixed().required(messages.required),
      classification: Yup.mixed().required(messages.required),
      // object_type: Yup.string().required(messages.required), // Removed as requested
      object_name: Yup.string().required(messages.required),
      sub_group: Yup.mixed().required(messages.required),
      acquisition: Yup.mixed().required(messages.required),
      material: Yup.mixed().required(messages.required),
      dyes: Yup.string().required(messages.required),
      motifs: Yup.string().required(messages.required),
      condition: Yup.mixed().required(messages.required),
      location: Yup.mixed().required(messages.required),
      place_of_origin: Yup.mixed().required(messages.required),
      source: Yup.mixed().optional(),
      source_remarks: Yup.string().optional(),
      price: Yup.number().optional(),
      other_info: Yup.string().required(messages.required),
      exhibition_history: Yup.string().required(messages.required),
      description: Yup.string().required(messages.required),
    }),
  }),
  date_of_aquisition: Yup.date().required(messages.required),
  date_of_entry: Yup.date().required(messages.required),
});
